export {
    getSwitcherVariants
} from "./switcherVariants";

export {
    getSwitcherBorderColor
} from "./border";

export type {
    SwitcherBorderColorConstantType,
    SwitcherBorderColorType
} from "./border";

export type {
    SwitcherVariantsConstantType,
    SwitcherVariantsType,
    SwitcherVariantType
} from "./switcherVariants";

export type {
    PreferenceSwitcherForm,
    PreferenceOptionType
} from "./type";
